import { DisplayListComponent } from "Components/Shared";
import { COACH } from "App/constants";

const Coaches = () => {
  return <DisplayListComponent title={COACH} />;
};

export default Coaches;
